import React from "react";
import {
  FlexCenter,
  FlexColumnCenter,
  FlexColumnSB,
} from "../../../constant/CustomeStyle";
import SetMenu from "../../../../assets/images/order/setmenu.png";
import Soup from "../../../../assets/images/order/soup.png";
import { Avatar, Grid } from "@mui/material";

const MenuList = () => {
  return (
    <div>
      <FlexCenter>
        <TopTitle />
      </FlexCenter>

      <div style={{ width: 710, marginTop: 30 }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {items.map((item, index) => (
            <SingleCard item={item} />
          ))}
        </Grid>
      </div>
    </div>
  );
};

const SingleCard = ({ item, handleSelection }) => (
  <FlexColumnCenter
    style={{
      background: "#FFF",
      width: 126,
      height: 111,
      borderRadius: 4,
      marginBottom: 20,
      boxShadow: "rgba(17, 17, 26, 0.1) 0px 1px 0px",
      cursor: "pointer",
    }}
    onClick={() => handleSelection(item.title)}
  >
    <Avatar
      sx={{
        width: "36px",
        height: "36px",
      }}
      variant="square"
      src={item.icon}
    />
    <div>{item.title}</div>
  </FlexColumnCenter>
);

const TopTitle = () => (
  <FlexCenter
    style={{
      width: 702,
      height: 55.15,
      color: "#FFF",
      background: "#333C4B",
      fontSize: 20,
      fontWeight: "600",
      fontFamily: `Poppins, sans-serif`,
    }}
  >
    Menu List
  </FlexCenter>
);

const items = [
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Salad", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Salad", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
  { title: "Set Menu", icon: SetMenu },
  { title: "Soup", icon: Soup },
];

export default MenuList;
